<!-- version 1.0.0 -->
<!-- 2017-9-19 -->
<template>
  <el-button size="small" @click="copyTxt">
    <slot></slot>
  </el-button>
</template>

<script>

export default {
  name: 'copyBtn',
  props: {
    // 需拷贝文本
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  methods: {
    copyTxt() {
      window.Mc.copyTxt(this.text)
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
</style>



// WEBPACK FOOTER //
// copy-btn.vue?3c84175d